import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import classnames from "classnames";
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import style from "./read-more-less.css";

function ReadMoreLess(_ref) {
  var _classnames;

  var children = _ref.children,
      readMoreLabel = _ref.readMoreLabel,
      readLessLabel = _ref.readLessLabel,
      itemAttributes = _ref.itemAttributes;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      expanded = _useState2[0],
      setExpanded = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1];

  var readMoreLessAreaElement = useRef(null);

  function handleReadMoreLess() {
    setExpanded(!expanded);
    analytics.event("read_more_less", "clicked");
  }

  function needsReadMoreLess() {
    // same as style.collapsedText max-height
    return height >= 190;
  }

  useEffect(function () {
    var currentElement = readMoreLessAreaElement.current;

    if (currentElement != null) {
      // there's no DOM in test environment
      var currentHeight = currentElement.clientHeight || 0;
      setHeight(currentHeight);
    }
  }, []);
  return React.createElement("div", {
    className: style.shortText
  }, React.createElement("div", _extends({
    className: classnames(style.expandableText, (_classnames = {}, _defineProperty(_classnames, style.expandedText, expanded), _defineProperty(_classnames, style.collapsedText, !expanded), _classnames))
  }, itemAttributes, {
    ref: readMoreLessAreaElement
  }), children, needsReadMoreLess() && React.createElement("div", {
    className: style.readMoreLessFadeElement
  })), needsReadMoreLess() && React.createElement("div", {
    className: style.readMoreLessText,
    onClick: handleReadMoreLess
  }, expanded ? readLessLabel : readMoreLabel, React.createElement(SVGIcon, {
    name: "round-chevron",
    rotate: expanded ? 270 : 90
  })));
}

ReadMoreLess.displayName = "ReadMoreLess";
ReadMoreLess.propTypes = {
  children: PropTypes.node,
  readMoreLabel: PropTypes.string,
  readLessLabel: PropTypes.string,
  itemAttributes: PropTypes.object
};
ReadMoreLess.defaultProps = {
  readMoreLabel: gettext("general.read_more"),
  readLessLabel: gettext("general.read_less"),
  itemAttributes: {}
};
export default ReadMoreLess;